import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    pageState: {}
  },
  mutations: {
    saveState(state, current) {
      for(let key in current) {
        state.pageState[key] = current[key];
      }
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js